export default $axios => ({
    getStoresLocations(params) {
        return $axios({
            method: 'GET',
            url: '/base/contacts',
            params: params ? params : null,
        });
    },
    getPageContacts() {
        return $axios({
            method: 'GET',
            url: '/base/page-contacts',
        });
    },
});
